<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

export default {
  name: "PageFooter",
  components: { DynamicComponentProduction },
  relatedComponents: ["Page Footer"],
  mixins: [DynamicElementMixin, DcHostMixin],
  options: [
    ReferencedComponentId,
    ContextBindings,
    new LayoutWidth({ "default": "fill" }),
    new LayoutHeight({ "default": "hug" }),
  ],
  data() {
    return {
      defaultComponentName: "Page Footer",
    };
  },
  elementPanelSettings: {
    tags: ["footer", "bottom"],
    displayName: "Footer",
    displayIcon: "footer",
    elementGroup: "general",
    elementType: "element",
  },
};
</script>
